import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// React Router does client-side navigation, which the browser doesn't treat
// like a real page load -- it leaves scroll position wherever it was on the
// previous page instead of resetting to top. Mounted once, above <Routes>,
// so every navigation gets this for free instead of each page/link needing
// its own window.scrollTo(0, 0).
export const ScrollToTop = () => {
	const { pathname } = useLocation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return null
}
